// 👇️ ts-ignore ignores any ts errors on the next line
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// // 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// @ts-ignore

import React, { useState, useRef, useEffect } from "react"
import { addNewPatient, getPatientDetail } from "../../core/services/api"
import { useHistory, useLocation, useParams } from "react-router"
import "./Addpatient.scss"
import Toast from "../../components/Toast"
import PrintRegistration from "./PrintRegistration"
import PatientEditForm from "../../components/patientEditForm/patientEditForm"
import { useDispatch, useSelector } from "react-redux"
import drawerAction from "../../core/store/actions/drawerAction"
import { ErrorCode, MocUserRole } from "../../core/services/models/Enums"
import { calculateAge } from "core/utils/date"
import Print from "components/Print/Print"
import { getDisabledCenters } from "core/services/api/migrationService"

function AddPatient() {
  const history = useHistory()
  const dispatch = useDispatch()
  const componentRef = useRef()
  const { patientId }: any = useParams()
  const userRole = useSelector((state) => state.user?.role)
  const userDetail = useSelector((state) => state.user?.userDetail)
  const [patientInfo, setpatientInfo] = useState<any>()
  const [isEditFlag, setIsEditFlag] = useState<boolean>()
  const [displayToast, toggleToast] = useState(false)
  const [isPatientFromDisabledCenter, setIsPatientFromDisabledCenter] = useState(false)
  const centerDetail = useSelector((state: any) => state?.user?.centerDetail)

  const [isEditedAlreadypatient, setIsEditedAlreadyPatient] =
    useState<any>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const location = useLocation()

  const [showPatientListButton, setShowPatientListButton] =
    useState<boolean>(true)

  const handleOnSubmit = (patInfo: any, consentData: any) => {
    if (isPatientFromDisabledCenter) {
      toggleToast({
        type: "error",
        text: `This patient belongs to a disabled center. Modifications are not allowed. Please contact the center for any changes.`,
        closeText: "Close",
      })
      history.push("/calendar")
      return
    }
    const temp = { ...patInfo }
    temp["name"] = `${patInfo?.firstName ? patInfo?.firstName?.trim() : ""} ${patInfo?.lastName ? patInfo?.lastName?.trim() : ""
      }`
    temp["generalConsent"] = consentData
    temp["lostToFollowUp"] = false
    delete temp["ageString"]
    delete temp["firstName"]
    delete temp["lastName"]
    delete temp["refunds"]
    delete temp["isEditedAlready"]
    if (temp["documents"]) delete temp["documents"]
    if (temp["category"] === "Others") {
      temp["category"] = temp["categoryOthers"]
    }
    if (temp["governmentScheme"] === "others") {
      temp["governmentScheme"] = temp["psuOthers"]
    }
    if (temp["category"] === "Trust") {
      temp["category"] = temp["trustOptions"]
    }
    if (temp["insuranceTPA"] === "Insurance") {
      temp["insuranceTPA"] = temp["insuranceOptions"]
    }
    if (temp["referredBy"] === "referredByOthers") {
      temp["referredBy"] = temp["referredByOthers"]
    }
    if (temp["referredBy"] && temp["referredBy"]["doctorName"] === "Others") {
      if (temp["referredBy"]["doctorNameOthers"]) {
        temp["referredBy"]["doctorName"] =
          temp["referredBy"]["doctorNameOthers"]
      }
    }

    if (temp?.tags !== null) {
      let tagValue = temp?.tags?.map((item) => {
        return item?.value
      })
      temp["tags"] = tagValue
    }
    const reffered = temp["referredBy"]
    temp["referredBy"] = reffered
    temp["category"] = temp["category"]?.toUpperCase()
    delete temp["categoryOthers"]
    delete temp["trustOptions"]
    delete temp["insuranceOptions"]
    delete temp["psuOthers"]
    delete temp["referredByOthers"]
    delete temp["totalPendingInvoices"]
    delete temp["advancePayment"]
    delete temp["totalAdvancePayment"]
    delete temp["securityDeposit"]
    delete temp["totalPendingAmount"]
    delete temp["oldDocuments"]
    if (temp && temp["referredBy"] && temp["referredBy"]["doctorNameOthers"]) {
      delete temp["referredBy"]["doctorNameOthers"]
    }

    addNewPatient(temp)
      .then((data) => {
        setIsLoading(false)
        handleToast(data)
        scroll()
      })

      .catch((err) => {
        console.log(err)
        setIsLoading(false)
        if (
          err?.response?.data?.code === ErrorCode.PHONE_NUMBER_ALREADY_EXISTS ||
          err?.response?.data?.code === ErrorCode.DUPLICATE_PATIENT
        ) {
          setShowPatientListButton(false)
        }
        toggleToast({
          type: "error",
          text: err?.response?.data?.message
            ? err?.response?.data?.message
            : `Unable to ${patientId ? "edit" : "create"
            } patient at the moment. Please try again after sometime`,
        })
        if (userRole === MocUserRole.SYSTEM_ADMIN) {
          history.push("/home")
        }
      })
  }

  function scroll() {
    const element = document.getElementById("appointments-page-wrapper")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  function handleToast(data) {
    toggleToast({
      type: "success",
      text: data?.isNameChanged
        ? `Patient - ${data?.mocId} detail updated successfully. Patient name is being updated in all previous records, will notify after completion`
        : `Patient - ${data?.mocId} has been ${patientId ? "edited" : "added"
        } successfully`,
      closeText: `${patientId ? "Close" : "Book Appointment"}`,
      data: data,
    })
  }

  useEffect(() => {
    if (userRole === MocUserRole.FRONT_DESK) {
      dispatch(
        drawerAction.setDrawerComponent({
          name: "CalendarDrawer",
        })
      )
    }

    return () => {
      dispatch(drawerAction.setDrawerComponent(null))
    }
  }, [])

  useEffect(() => {
    if (patientId && userRole === MocUserRole?.PATIENT) {
      setIsEditFlag(true)
    } else {
      setIsEditFlag(false)
    }
  }, [])

  useEffect(() => {
    if (patientInfo?.isEditedAlready === true) {
      setIsEditedAlreadyPatient(true)
    }
  }, [patientInfo?.isEditedAlready])

  useEffect(() => {
    if (patientId) {
      getPatientDetail(patientId)
        .then((res: any) => {
          const temp = { ...res }
          temp["ageString"] = calculateAge(res?.dob)
          let name = res?.name?.trim().split(/\s+/)
          temp["firstName"] = name.shift()
          temp["lastName"] = name.join(" ")
          setpatientInfo(temp)
          setIsLoading(false)
        })
        .catch((err) => {
          console.log("err", err)
          setIsLoading(false)
        })
    } else {
      setpatientInfo(null)
    }
  }, [patientId])

  useEffect(() => {
    const centerIds = new Set<string>()
    if (centerDetail?.id) {
      centerIds.add(centerDetail.id)
    }
    if (patientInfo?.centerId && patientInfo.centerId !== centerDetail?.id) {
      centerIds.add(patientInfo.centerId)
    }
    if (centerIds.size > 0) {
      getDisabledCenters()
        .then((response) => {
          const disabledCenters = response?.disabledCenters || []
          const disabledCenter = disabledCenters.find(
            (center: any) => centerIds.has(center.id)
          )
          if (disabledCenter) {
            setIsPatientFromDisabledCenter(true)
            toggleToast({
              type: "warning",
              text: `${disabledCenter.name} has been disabled. Modifications are not allowed.`,
              closeText: "Close",
            })
          }
        })
        .catch((error) => {
          console.error("Error fetching disabled centers:", error)
        })
    }
  }, [centerDetail, patientInfo])

  return (
    <div className="add-patient-wrapper">
      <PrintRegistration
        printRef={componentRef}
        centerDetail={centerDetail}
        patientDetail={patientInfo}
      />
      <div className="col-md-12 col-lg-12">
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )}
        <div className="heading">
          {!patientId ? (
            <div
              className="back-image"
              onClick={() => {
                history.push("/")
              }}
            >
              <img
                src="../../assets/images/back-icon.svg"
                height={"60px"}
                width={"60px"}
                alt="back button"
              />
            </div>
          ) : null}

          <div className="add-patient-text">
            {patientId ? "Edit detail" : "Add Patient"}
            <span
              className="print-button cursor-pointer"
              style={{ paddingLeft: "15px" }}
            >
              <Print
                componentRef={componentRef}
              />
            </span>
          </div>
        </div>
        {isEditFlag && isEditedAlreadypatient && (
          <Toast
            textMessage={
              "Please contact the center if there is any change in information"
            }
            onClose={() => {
              setIsEditFlag(false)
            }}
            onCloseText={"Close"}
            onClick={() => history.push("../patientList")}
            type={"warning"}
          />
        )}
        {displayToast ? (
          <Toast
            textMessage={displayToast?.text}
            onClose={() => {
              if (isPatientFromDisabledCenter) {
                toggleToast(false)
                history.push("/calendar")
                return
              }
              if (displayToast?.type === "error") {
                toggleToast(false)
              } else if (location?.pathname === `/editPatient/${patientId}`) {
                toggleToast(false)
                history.push("/calendar")
              } else if (
                userRole === MocUserRole.PATIENT &&
                location?.pathname === `/editPatient/${patientId}`
              ) {
                toggleToast(false)
                history.push("/")
              } else {
                toggleToast(false)
                history.push("/bookAppointment", displayToast?.data)
              }
            }}
            onCloseText={
              displayToast?.closeText ? displayToast?.closeText : "Close"
            }
            onClickText={
              patientId || !showPatientListButton ? null : "Patient List"
            }
            onClick={() => history.push("../patientList")}
            type={displayToast?.type}
          />
        ) : (
          ""
        )}
        <PatientEditForm
          patientDetail={patientInfo}
          onSubmit={handleOnSubmit}
          userRole={userRole}
          userDetail={userDetail}
        />
      </div>
    </div>
  )
}

export default AddPatient
